export default __webpack_public_path__ + "static/media/byoc-step2.6f39745d.svg";